import { Disclosure, Menu, Transition } from "@headlessui/react";
import { Fragment, useState, React } from "react";
import { HomeIcon, PlusIcon } from "@heroicons/react/24/outline";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import Cookies from "js-cookie";
import { useAuthRedirect } from "../Utils/auth";

export default function Navbar() {
  useAuthRedirect();

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const [currentTab, setCurrentTab] = useState(true);

  const navigation = [
    {
      name: "New Record",
      href: "/new-record",
      icon: HomeIcon,
      current: currentTab == "new-record" ? true : false,
    },
    {
      name: "Insurance",
      href: "/insurance",
      icon: HomeIcon,
      current: currentTab == "insurance" ? true : false,
    },
    {
      name: "Submitted Business",
      href: "/submitted",
      icon: HomeIcon,
      current: currentTab == "submitted" ? true : false,
    },
    {
      name: "Compliance",
      href: "/compliance",
      icon: HomeIcon,
      current: currentTab == "compliance" ? true : false,
    },
    {
      name: "Statements In",
      href: "/statements-in/summary",
      icon: HomeIcon,
      current: currentTab == "statements-in/summary" ? true : false,
    },
    {
      name: "Matching",
      href: "/matching",
      icon: HomeIcon,
      current: currentTab == "matching" ? true : false,
    },
    {
      name: "Advisor Statements",
      href: "/advisor-statement",
      children: [
        { name: "Create Statement", href: "/advisor-statement" },
        { name: "Statements", href: "/advisor-statements" },
      ],
    },
    {
      name: "Companies",
      href: "/companies",
      icon: PlusIcon,
      current: currentTab == "companies" ? true : false,
    },
    {
      name: "Providers",
      href: "/providers",
      icon: PlusIcon,
      current: currentTab == "providers" ? true : false,
    },
    {
      name: "Strategies",
      href: "/strategies",
      icon: PlusIcon,
      current: currentTab == "strategies" ? true : false,
    },
    {
      name: "Users",
      href: "/users",
      icon: PlusIcon,
      current: currentTab == "users" ? true : false,
    },
  ];

  const handleLogout = () => {
    Cookies.remove("token");
    window.location.href = "/";
  };

  return (
    <header>
      <nav class="bg-white border-gray-200 px-4 lg:px-6 py-2.5 dark:bg-gray-900 antialiased">
        <div class="flex flex-wrap justify-between items-center">
          <div class="flex justify-start items-center">
            <img
              src="https://money-trove.com/wp-content/uploads/2019/06/trove-logo-standard-300.png"
              class="mr-12 h-12"
              alt="Finance Manager Logo"
            />

            <div class="hidden justify-between items-center w-full lg:flex lg:w-auto lg:order-1">
              <ul className="flex flex-col mt-4 space-x-6 font-medium lg:flex-row xl:space-x-8 lg:mt-0">
                {navigation.map((item) => (
                  <li key={item.name} className="relative group">
                    <a
                      href={item.href}
                      className="block text-gray-700 text-xs hover:text-primary-700 dark:text-gray-400 dark:hover:text-white"
                    >
                      <span className="inline-flex items-center">
                        {item.name}
                        {item.children && (
                          <svg
                            className="ml-1 h-3 w-3"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
                          </svg>
                        )}
                      </span>
                    </a>

                    {item.children && (
                      <div
                        className="
            absolute left-0 top-full z-50
            hidden w-56 rounded-md bg-white py-2 shadow-lg ring-1 ring-black/5
            group-hover:block group-focus-within:block
            dark:bg-gray-800
          "
                      >
                        {item.children.map((sub) => (
                          <a
                            key={sub.name}
                            href={sub.href}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-700"
                          >
                            {sub.name}
                          </a>
                        ))}
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div class="mr-12 flex justify-between items-center lg:order-2">
            <a
              onClick={(e) => {
                e.preventDefault();
                handleLogout();
              }}
            >
              <div className="flex flex-row">
                <div className="block font-medium text-gray-700 hover:text-primary-700 dark:text-gray-400 dark:hover:text-white">
                  Log out
                </div>

                <img
                  class="w-auto h-4 mr-3 ml-3 mt-1"
                  src={require("../Assets/images/logout.png")}
                />
              </div>
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}
